import type { Dispatch, SetStateAction } from "react";
import SelectPersonStatus from "~components/SelectPersonStatus";
import SelectPersonGender from "~components/SelectPersonGender";
import SelectNationality from "~components/SelectNationality";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import { RoleStatuses } from "~enums/roleStatuses";

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setNationality: Dispatch<SetStateAction<string | undefined>>;
  setGender: Dispatch<SetStateAction<string | undefined>>;
  setStatus: Dispatch<SetStateAction<RoleStatuses | undefined>>;
  disabled?: boolean;
  resetPagination: () => void;
};

export const AddPersonRolesModalFilters = ({
  setGender,
  setNationality,
  searchValue,
  setSearchValue,
  setStatus,
  disabled = false,
  resetPagination,
}: Props) => (
  <>
    <SelectNationality
      onChange={(value) => {
        resetPagination();
        setNationality(value as string | undefined);
      }}
      disabled={disabled}
    />
    <SelectPersonGender
      onChange={(value) => {
        resetPagination();
        setGender(value as string | undefined);
      }}
      disabled={disabled}
    />
    <SelectPersonStatus
      onChange={(value) => {
        resetPagination();
        setStatus(value as RoleStatuses | undefined);
      }}
      disabled={disabled}
    />
    <SearchFilter
      initial={searchValue}
      searchValue={searchValue}
      doSearch={(value) => {
        resetPagination();
        setSearchValue(value);
      }}
      placeholderIntlKey="search.two.letters"
    />
  </>
);
